var _excluded = ["content", "aside", "asideWidthSpace", "asideDirection", "asidePushTopSpace", "asideFloatingStartBreakpoint", "gutterSpace", "mobileFixedAsideBreakpointRef", "hasHeaderBottomBar"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useState } from "react";
import styled, { createGlobalStyle, css } from "styled-components";
import { slideInVertical } from "../../../animations/slideIn";
import ResizeDetector from "../../../helpers/ResizeDetector";
import useBreakpoint from "../../../hooks/useBreakpoint";
import useIsomorphicLayoutEffect from "../../../hooks/useIsomorphicLayoutEffect";
import { animationDuration, headerBottomBarHeight, pageGutterSpace, zIndex } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
export var defaultProps = {
  asideDirection: "right",
  asideWidthSpace: 42,
  asideFloatingStartBreakpoint: "large",
  gutterSpace: 4,
  hasHeaderBottomBar: false
};
var Container = styled.div.withConfig({
  componentId: "sc-1fliqrm-0"
})(function (_ref) {
  var $breakpointValue = _ref.$breakpointValue,
    $hasInvertedOrder = _ref.$hasInvertedOrder,
    $gutterSpace = _ref.$gutterSpace;
  return css(["", "{display:grid;grid-gap:", ";grid-template-columns:1fr auto;", "}"], breakpoint($breakpointValue), space($gutterSpace), $hasInvertedOrder && css(["grid-template-columns:auto 1fr;"]));
});
var Aside = styled.div.withConfig({
  componentId: "sc-1fliqrm-1"
})(function (_ref2) {
  var $widthSpace = _ref2.$widthSpace,
    $hasInvertedOrder = _ref2.$hasInvertedOrder,
    $pushTopSpace = _ref2.$pushTopSpace,
    $breakpointValue = _ref2.$breakpointValue,
    $isHidden = _ref2.$isHidden,
    $hasHeaderBottomBar = _ref2.$hasHeaderBottomBar;
  var headerBottomBarUnit = $hasHeaderBottomBar ? unit(headerBottomBarHeight) : 0;
  var topSpace = $pushTopSpace ? space(pageGutterSpace + $pushTopSpace) : space(pageGutterSpace);
  return css(["", "{position:sticky;top:", ";align-self:flex-start;width:", ";", "}", "{display:", ";position:fixed;z-index:", ";right:0;bottom:0;left:0;animation:", " ", "s;}"], breakpoint($breakpointValue), headerBottomBarUnit ? "calc(".concat(headerBottomBarUnit, " + ").concat(topSpace, ")") : topSpace, space($widthSpace), $hasInvertedOrder && css(["order:-1;"]), breakpoint("small", $breakpointValue), $isHidden && "none", zIndex.FloatingAside, slideInVertical(), animationDuration.slow / 1000);
});
var BodyAdditionalSpace = createGlobalStyle(function (_ref3) {
  var $height = _ref3.$height;
  return css(["body{padding-bottom:", " !important;}"], unit($height));
});
function ContentWithFloatingAsideOrg(_ref4) {
  var content = _ref4.content,
    aside = _ref4.aside,
    _ref4$asideWidthSpace = _ref4.asideWidthSpace,
    asideWidthSpace = _ref4$asideWidthSpace === void 0 ? defaultProps.asideWidthSpace : _ref4$asideWidthSpace,
    _ref4$asideDirection = _ref4.asideDirection,
    asideDirection = _ref4$asideDirection === void 0 ? defaultProps.asideDirection : _ref4$asideDirection,
    asidePushTopSpace = _ref4.asidePushTopSpace,
    _ref4$asideFloatingSt = _ref4.asideFloatingStartBreakpoint,
    asideFloatingStartBreakpoint = _ref4$asideFloatingSt === void 0 ? defaultProps.asideFloatingStartBreakpoint : _ref4$asideFloatingSt,
    _ref4$gutterSpace = _ref4.gutterSpace,
    gutterSpace = _ref4$gutterSpace === void 0 ? defaultProps.gutterSpace : _ref4$gutterSpace,
    mobileFixedAsideBreakpointRef = _ref4.mobileFixedAsideBreakpointRef,
    _ref4$hasHeaderBottom = _ref4.hasHeaderBottomBar,
    hasHeaderBottomBar = _ref4$hasHeaderBottom === void 0 ? defaultProps.hasHeaderBottomBar : _ref4$hasHeaderBottom,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    asideHeight = _useState2[0],
    setAsideHeight = _useState2[1];
  var _useState3 = useState(!!mobileFixedAsideBreakpointRef),
    _useState4 = _slicedToArray(_useState3, 2),
    asideHidden = _useState4[0],
    setAsideHidden = _useState4[1];
  var hasInvertedOrder = asideDirection === "left";
  var handleScroll = useCallback(function () {
    if (!mobileFixedAsideBreakpointRef) {
      return;
    }
    var breakpointRefCurrent = mobileFixedAsideBreakpointRef.current;
    if (breakpointRefCurrent) {
      var breakpointValue = breakpointRefCurrent.offsetTop + breakpointRefCurrent.clientHeight;
      if (window.scrollY > breakpointValue) {
        setAsideHidden(false);
      } else {
        setAsideHidden(true);
      }
    }
  }, [mobileFixedAsideBreakpointRef, setAsideHidden]);
  useIsomorphicLayoutEffect()(function () {
    window.addEventListener("scroll", handleScroll);
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [asideHidden, handleScroll]);
  var isAsideFixedToBottom = useBreakpoint("small", asideFloatingStartBreakpoint);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isAsideFixedToBottom ? /*#__PURE__*/React.createElement(BodyAdditionalSpace, {
    $height: asideHeight !== null && asideHeight !== void 0 ? asideHeight : 0
  }) : null, /*#__PURE__*/React.createElement(Container, _extends({
    $breakpointValue: asideFloatingStartBreakpoint,
    $hasInvertedOrder: hasInvertedOrder,
    $gutterSpace: gutterSpace
  }, restProps), /*#__PURE__*/React.createElement("div", null, content), /*#__PURE__*/React.createElement(ResizeDetector, {
    setHeight: function setHeight(height) {
      return setAsideHeight(height);
    }
  }, /*#__PURE__*/React.createElement(Aside, {
    $widthSpace: asideWidthSpace,
    $hasInvertedOrder: hasInvertedOrder,
    $pushTopSpace: asidePushTopSpace,
    $breakpointValue: asideFloatingStartBreakpoint,
    $isHidden: asideHidden,
    $hasHeaderBottomBar: hasHeaderBottomBar
  }, aside))));
}
export default ContentWithFloatingAsideOrg;